import { render, staticRenderFns } from "./InterfaceSimplifiedRedirector.vue?vue&type=template&id=92a03160&scoped=true&"
import script from "./InterfaceSimplifiedRedirector.vue?vue&type=script&lang=js&"
export * from "./InterfaceSimplifiedRedirector.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceSimplifiedRedirector.vue?vue&type=style&index=0&id=92a03160&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a03160",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
